<script setup lang="ts">
import { NImage } from 'naive-ui'
import { ref, useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  src?: string
  alt?: string
  width?: string | number
  height?: string | number
  objectFit?: 'fill' | 'contain' | 'cover' | 'none' | 'scale-down'
  previewSrc?: string
  fallbackSrc?: string
  showToolbar?: boolean
  showToolbarTooltip?: boolean
  loading?: 'eager' | 'lazy'
  lazy?: boolean
  previewDisabled?: boolean
  onError?: () => void
  onLoad?: () => void
}>(), {
  src: undefined,
  alt: undefined,
  width: undefined,
  height: undefined,
  objectFit: 'fill',
  previewSrc: undefined,
  fallbackSrc: undefined,
  showToolbar: true,
  showToolbarTooltip: true,
  loading: 'lazy',
  lazy: false,
  previewDisabled: false,
})

const emit = defineEmits<{
  'error': []
  'load': []
}>()

const attrs = useAttrs()
const isLoaded = ref<boolean>(false)

const onError = () => {
  emit('error')
}

const onLoad = () => {
  isLoaded.value = true
  emit('load')
}
</script>

<template>
  <NImage
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :object-fit="objectFit"
    :preview-src="previewSrc"
    :fallback-src="fallbackSrc"
    :show-toolbar="showToolbar"
    :show-toolbar-tooltip="showToolbarTooltip"
    :loading="loading"
    :lazy="lazy"
    :preview-disabled="previewDisabled"
    v-bind="attrs"
    :class="{ 'loading-0': !isLoaded, 'loading-100': isLoaded }"
    @error="onError"
    @load="onLoad"
  />
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
